import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { MultimediaManagerDialogLayoutService } from 'src/app/modules/multimedia-manager/multimedia-manager-dialog-layout/multimedia-manager-dialog-layout.service';
import { MultimediaManagerDialogItemTypes } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';
import { MultimediaManagerDialogService } from '../multimedia-manager-dialog/multimedia-manager-dialog.service';
import { MultimediaManagerDialogSidenavFolder } from './multimedia-manager-dialog-sidenav-folder.model';
import { MultimediaManagerDaoService } from '../multimedia-manager-daos/multimedia-manager-dao.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-multimedia-manager-dialog-sidenav',
  templateUrl: './multimedia-manager-dialog-sidenav.component.html',
  styleUrls: ['./multimedia-manager-dialog-sidenav.component.scss']
})
export class MultimediaManagerDialogSidenavComponent implements OnInit {

  folders: Array<MultimediaManagerDialogSidenavFolder>;
  currentFolder: MultimediaManagerDialogSidenavFolder;
  occupiedSize;

  constructor(private multimediaManagerDialogService: MultimediaManagerDialogService,
              private multimediaManagerDialogLayoutService: MultimediaManagerDialogLayoutService,
              private eRef: ElementRef,
              private cd: ChangeDetectorRef,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this._getInitialFolders();
    this._getStorageOccupied();
    this.multimediaManagerDialogService.listenFolderChanged().subscribe(
      (res) => {
        this.currentFolder = res.currentFolder;
      }
    );
    this.multimediaManagerDialogService.listenGoHome().subscribe(
      (res) => {
        this._getInitialFolders();
      }
    );
  }

  public openFolder(folder) {
    if (!folder.editing) {
      this.multimediaManagerDialogService.folderChanged(folder);
    }
  }

  private _getFolders(folderInternalId) {
    this.multimediaManagerDialogService.getItems(folderInternalId).subscribe(
      (res) => {
        this.folders = res.items.filter(e => e.Type === MultimediaManagerDialogItemTypes.FOLDER);
        this.multimediaManagerDialogService.folderChanged(this.folders[1]);
      },
      (error) => {
        this.snackbarService.open('error', error);
      }
    );
  }

  private _getInitialFolders() {
    this.multimediaManagerDialogService.getInitialFolders().subscribe(
      (res) => {
        this.folders = res.items.filter(e => e.Type === MultimediaManagerDialogItemTypes.FOLDER);
        this.multimediaManagerDialogService.folderChanged(this.folders[0]);
      },
      (error) => {
        this.snackbarService.open('error', error);
      }
    );
  }

  public _getStorageOccupied() {
    this.multimediaManagerDialogLayoutService.getStorageOccupied().pipe(
      tap(o => this.occupiedSize = o['size'])
    ).subscribe();
  }
}
